// @flow
import React, { PureComponent } from 'react'
import { RegularRow } from '../../utils/Grid'
import utmLinkGenerator from '../../utils/UTMLinkGenerator'
import WidgetContainer from '../../containers/WidgetContainer'
import { ImageCol, ListCol } from './StyledCols'
import VideoLink from './StyledVideoLink'
import VideoImageWrapper from './StyledVideoImageWrapper'
import VideoImage from './StyledVideoImage'
import VideoCaption from './StyledVideoCaption'
import VideoList from './StyledVideoList'
import VideoListBox from './StyledVideoListBox'
import ArticleOverlay from '../../utils/ArticleOverlay'
import styled from 'styled-components'
import { type VideoWidgetProps, type VideoWidgetState } from './Types'

const VideoRow = styled(RegularRow)`
  display: -ms-flexbox;
  -ms-flex-direction: row;
  overflow: hidden;
`

const ROTATION_INTERVAL: number = 5000

export default class Video extends PureComponent<VideoWidgetProps, VideoWidgetState> {
  constructor (props: VideoWidgetProps) {
    super(props)

    this.state = {
      active: 0,
      rotateInterval: null
    }

    this.handleLeave = this.handleLeave.bind(this)
    this.rotateCarousel = this.rotateCarousel.bind(this)
    this.handleImageEnter = this.handleImageEnter.bind(this)
  }

  componentDidMount () {
    this.state.rotateInterval = this.startCarouselRotation()
  }

  componentWillUnmount () {
    this.clearCarouselRotation()
  }

  rotateCarousel: () => void
  rotateCarousel (): void {
    const {
      active
    } = this.state

    const {
      widget: {
        boxes = []
      }
    } = this.props

    const newActive = active < boxes.length - 1 ? active + 1 : 0

    this.setActive(newActive)
  }

  startCarouselRotation (): IntervalID {
    return setInterval(this.rotateCarousel, ROTATION_INTERVAL)
  }

  clearCarouselRotation (): void {
    clearInterval(this.state.rotateInterval)
  }

  setActive (active: number): void {
    this.setState({ active })
  }

  handleArticleEnter (position: number): void {
    this.clearCarouselRotation()
    this.setActive(position)
  }

  handleLeave: () => void
  handleLeave () {
    this.clearCarouselRotation()
    this.setState({
      rotateInterval: this.startCarouselRotation()
    })
  }

  handleImageEnter: () => void
  handleImageEnter () {
    this.clearCarouselRotation()
  }

  render () {
    const {
      isOpening,
      widget,
      widget: {
        boxes = [],
        utmMedium
      }
    } = this.props

    const {
      active
    } = this.state

    if (!boxes.length) return null

    const activeBox = Object.assign({}, boxes[active], {
      image: boxes[active] ? boxes[active].images['16_9'] : ''
    })

    const activeUtmLink = utmLinkGenerator.createLink(activeBox.link, {
      utmMedium,
      utmTerm: `position-${active}`,
      utmCampaign: activeBox.source
    })

    return (
      <WidgetContainer widget={widget} isOpening={isOpening}>
        <VideoRow>
          <ImageCol>
            <VideoLink href={activeUtmLink} onMouseOver={this.handleImageEnter} onMouseOut={this.handleLeave}>
              <VideoImageWrapper>
                <VideoImage src={activeBox.image} alt={activeBox.title}/>
                <ArticleOverlay className='video'/>
              </VideoImageWrapper>
              <VideoCaption>
                { activeBox.title }
              </VideoCaption>
            </VideoLink>
          </ImageCol>
          <ListCol>
            <VideoList>
              {
                boxes.map((box, index) => {
                  const {
                    featuredType,
                    guid,
                    link,
                    source,
                    title
                  } = box

                  const utmLink = utmLinkGenerator.createLink(link, {
                    utmMedium,
                    utmTerm: `position-${index}`,
                    utmCampaign: source
                  })

                  return (
                    <VideoListBox
                      className={boxes[active] === box ? 'active' : ''}
                      featuredSize='inline'
                      featuredType={featuredType}
                      key={guid}
                      link={utmLink}
                      onMouseOver={() => this.handleArticleEnter(index)}
                      onMouseOut={this.handleLeave}
                      title={title}
                    />
                  )
                })
              }
            </VideoList>
          </ListCol>
        </VideoRow>
      </WidgetContainer>
    )
  }
}
